export const passengersToPersonCounter = (passengers, selectedReservation) => {
    if (!selectedReservation) return;

    const TYPE_MAP = {
        ADULT: "adult",
        CHILD: "child",
        INFANT: "infant",
        ADT: "adult",
        CHD: "child",
        INF: "infant",
    };

    const counter = passengers?.reduce(
        (acc, passenger) => {
            const type = TYPE_MAP?.[passenger?.type];

            if (type in acc) acc[type]++;

            return acc;
        },
        { adult: 0, child: 0, infant: 0 },
    );

    return {
        personCounter: {
            ...counter,
            totalPersons: counter?.adult + counter?.child + counter?.infant,
        },
    };
};
